export default {
  ADD_PERSON_DUPE_CHECK_SEEN: 'dupeCheckModalSeen',
  BACKGROUND_IMAGE_KEY: 'customBackgroundImage',
  HIDDEN_IDS: (pofId) => `hiddenIds_${pofId}`,
  HIDDEN_IDS_INITIAL: [],
  SHOW_AVATARS: 'showAvatars',
  SHOW_AVATARS_INITIAL: true,
  SHOW_PORTRAITS: 'showPortraits',
  SHOW_PORTRAITS_INITIAL: true,
  STORE_NAME: 'chineseTreeDesigns',
  STORE_VISIBILITY: { storeName: 'visibilityPreferences', type: 'local' },
}
